var _path, _path2, _path3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRustcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32 65.7861C49.6732 65.7861 64 51.4593 64 33.7861C64 16.113 49.6732 1.78613 32 1.78613C14.3269 1.78613 0 16.113 0 33.7861C0 51.4593 14.3269 65.7861 32 65.7861Z",
    fill: "#B5904A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "url(#paint0_linear_1918_4748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6732 64 64 49.6732 64 32C64 14.3269 49.6732 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6732 14.3269 64 32 64Z",
    fill: "#D3A64E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1918_4748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 58.854C46.8549 58.854 58.8975 46.8114 58.8975 31.9562C58.8975 17.1009 46.8549 5.05832 31.9997 5.05832C17.1444 5.05832 5.10181 17.1009 5.10181 31.9562C5.10181 46.8114 17.1444 58.854 31.9997 58.854Z",
    fill: "#FCCD71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1918_4748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9554 33.0005C45.4997 40.5919 40.2092 42.4548 29.7026 44.7468C19.4322 46.9873 8.68868 40.5919 17.5528 41.0378C18.4055 41.0057 19.2328 40.9681 20.0366 40.9259C21.7447 40.835 23.3441 40.7231 24.8429 40.5919C26.6833 40.4304 28.3724 40.2404 29.9256 40.0275C29.9636 40.022 30.0008 40.0175 30.0379 40.0129C30.9758 39.8826 31.8638 39.7449 32.7057 39.599C32.5498 39.6155 32.3269 39.6403 32.0306 39.6752C28.9759 40.0358 26.2792 39.1512 25.1709 38.7099L25.2769 38.1033L26.1632 33.0272L26.1994 32.8225L27.0322 28.0519C27.0412 28.0042 27.0258 27.9546 26.9914 27.9189L26.8491 27.7675L26.7866 27.7014L21.6042 22.2031C21.5653 22.1618 21.5073 22.1426 21.4502 22.1499L21.2019 22.1838L14.1973 23.1501C14.0142 23.1749 13.9236 22.9491 14.0776 22.8537L15.6027 21.9214L19.4322 19.5788L21.9685 18.0271C22.0193 17.9959 22.0845 17.9922 22.1389 18.0179L34.9792 24.0365C35.0019 24.0466 35.0209 24.0613 35.0363 24.0796L36.7508 26.0717L37.2682 26.6737L42.8094 33.1107L43.8379 34.3054L44.8981 35.5377C44.9616 35.612 44.9434 35.7222 44.8592 35.7745L43.9793 36.3195C43.9956 36.3122 44.0119 36.3039 44.0273 36.2966C47.0249 34.8798 48.4494 33.5621 49.9554 33.0005Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9267 40.0261C28.3735 40.239 26.6844 40.429 24.844 40.5904V40.5886C26.4588 40.4482 28.3644 40.2262 29.9267 40.0261Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6575 22.7082L40.7572 23.0386C40.7962 23.1615 40.8551 23.2625 40.9266 23.3304L41.4395 23.501L40.9266 23.6717C40.8551 23.7387 40.7962 23.8405 40.7572 23.9635L40.6575 24.2938L40.5578 23.9635C40.5189 23.8405 40.46 23.7396 40.3884 23.6717L39.8755 23.501L40.3884 23.3304C40.46 23.2634 40.5189 23.1615 40.5578 23.0386L40.6575 22.7082Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7121 27.9569L18.8834 28.524C18.9504 28.736 19.0519 28.9094 19.1752 29.025L20.0569 29.3186L19.1752 29.6123C19.0519 29.7279 18.9504 29.9022 18.8834 30.1133L18.7121 30.6804L18.5408 30.1133C18.4738 29.9013 18.3723 29.7279 18.2491 29.6123L17.3665 29.3195L18.2482 29.0259C18.3714 28.9103 18.4729 28.736 18.5399 28.5249L18.7112 27.9578L18.7121 27.9569Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0974 29.3186L46.2831 29.9334C46.3556 30.1637 46.4662 30.3519 46.5994 30.4776L47.5554 30.796L46.5994 31.1144C46.4662 31.2401 46.3556 31.4282 46.2831 31.6585L46.0974 32.2733L45.9116 31.6585C45.8391 31.4282 45.7285 31.2401 45.5953 31.1144L44.6384 30.7969L45.5944 30.4785C45.7276 30.3528 45.8382 30.1647 45.9107 29.9343L46.0964 29.3196L46.0974 29.3186Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9597 30.6666L22.035 30.9162C22.0649 31.0098 22.1093 31.0859 22.1636 31.1373L22.5524 31.2667L22.1636 31.3961C22.1093 31.4475 22.0649 31.5236 22.035 31.6172L21.9597 31.8668L21.8845 31.6172C21.8546 31.5236 21.8102 31.4475 21.7559 31.3961L21.3662 31.2667L21.755 31.1373C21.8093 31.0859 21.8537 31.0098 21.8836 30.9162L21.9597 30.6666Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0391 40.0115C30.9769 39.8812 31.865 39.7435 32.7068 39.5976C33.6465 39.504 32.1885 39.7343 30.0391 40.0115Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3706 35.0179L25.3199 35.3271C22.2217 35.3069 20.1674 34.8811 20.0605 34.0957C19.8784 32.7569 25.4313 30.8795 32.4614 29.9013C32.6399 29.8765 32.8184 29.8518 32.9969 29.8288C26.7688 30.7492 21.939 32.5046 22.1157 33.8094C22.2009 34.4361 23.4269 34.8481 25.3706 35.016V35.0179Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1325 29.905L40.3314 28.9947C40.6368 28.602 40.76 28.2395 40.6803 27.9193C40.1937 25.9795 32.3961 26.3006 23.1052 28.6075C23.3744 28.5359 23.6444 28.4653 23.9162 28.3946C34.3625 25.7088 43.2357 25.1445 43.7341 27.1329C43.9171 27.8624 42.9484 28.8341 41.1325 29.905Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7915 34.8976L43.6833 33.6103L43.608 33.5231C43.5047 33.4029 43.338 33.3653 43.193 33.4267C40.9593 34.3847 38.0587 35.2381 34.9832 35.84C31.7935 36.4649 28.6753 36.7668 26.2042 36.6934C25.965 36.6861 25.7394 36.676 25.5273 36.6622C25.3434 36.6503 25.1812 36.7797 25.1495 36.9632L24.8486 38.6864C24.8115 38.8993 24.9637 39.0993 25.1775 39.1149C25.2736 39.1214 25.3706 39.1278 25.4693 39.1342C25.9478 39.1617 26.448 39.1755 26.9708 39.1755C29.4583 39.1755 32.4069 38.8626 35.448 38.2662C38.954 37.5807 42.2089 36.5925 44.6692 35.4711C44.7253 35.2069 44.7353 35.1619 44.7924 34.8976H44.7915Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8017 34.1135L38.1104 34.9317C37.5246 35.1097 37.1924 35.7349 37.3682 36.328L37.5704 37.01C37.7462 37.6031 38.3636 37.9396 38.9493 37.7616L41.6407 36.9434C42.2264 36.7653 42.5587 36.1402 42.3829 35.547L42.1807 34.865C42.0049 34.2719 41.3875 33.9354 40.8017 34.1135Z",
    stroke: "#B18837",
    strokeWidth: 1.38767,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8517 34.9647L39.524 35.6724C39.338 35.7289 39.2325 35.9272 39.2882 36.1153C39.344 36.3034 39.5399 36.41 39.7259 36.3535L42.0536 35.6459C42.2396 35.5893 42.3452 35.391 42.2894 35.2029C42.2337 35.0148 42.0377 34.9082 41.8517 34.9647Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.8594 35.774L43.9795 36.319C43.9958 36.3117 44.0121 36.3034 44.0275 36.2961C36.9839 40.1023 35.6319 34.6352 35.6319 34.6352L33.4299 25.9712L22.2179 19.5783H19.4324L21.9687 18.0266C22.0195 17.9954 22.0847 17.9918 22.1391 18.0174L34.9794 24.036C35.0021 24.0461 35.0211 24.0608 35.0365 24.0791L36.751 26.0712L37.2684 26.6732L42.8096 33.1102L43.8381 34.3049L44.8983 35.5372C44.9618 35.6116 44.9436 35.7217 44.8594 35.774Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M49.9557 33.0001C48.1149 35.2687 46.6554 41.6828 29.75 44.7049C19.2768 46.8837 8.68896 40.5914 17.5531 41.0373C18.4058 41.0052 19.2331 40.9676 20.0369 40.9254C22.7155 42.2678 34.0951 46.5787 49.9557 33.0001Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4234 18.6818L22.0233 18.3258C22.0441 18.3129 22.0704 18.312 22.0921 18.3221L23.0073 18.7323C23.0907 18.7699 23.0499 18.8974 22.9602 18.8772L22.0794 18.679C22.0677 18.6763 22.0559 18.6763 22.045 18.679L21.4805 18.8222C21.3953 18.8433 21.3482 18.7268 21.4234 18.6818Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M33.2107 23.501L34.8173 24.2938L36.0071 25.6712L34.7004 24.5122L33.2107 23.501Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M15.603 21.9209L21.2022 22.1834L14.1975 23.1496C14.0145 23.1744 13.9238 22.9486 14.0779 22.8532L15.603 21.9209Z",
    fill: "#B18837"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M27.0324 28.0514C27.0415 28.0037 27.0261 27.9542 26.9916 27.9184L26.8494 27.767L26.7869 27.7009L21.6045 22.2026L28.8022 27.2669L25.2772 38.1028L26.1634 33.0267L26.1997 32.822L27.0324 28.0514Z",
    fill: "#B18837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1918_4748",
    x: 5.10181,
    y: 5.05832,
    width: 53.7957,
    height: 53.7957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.3814
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.708333 0 0 0 0 0.566624 0 0 0 0 0.289236 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1918_4748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1918_4748",
    x1: 31.8724,
    y1: -0.0000960841,
    x2: 31.8071,
    y2: 63.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A89EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD1B62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1918_4748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 28,
    fill: "white",
    transform: "translate(14 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRustcoin);
export default __webpack_public_path__ + "static/media/rustcoin.8f5d62d718cd0429abf61a837eecfc01.svg";
export { ForwardRef as ReactComponent };